
import {  isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";

export const ScreeningUrinalysis = (props)=>{
    const stackedFieldStyle = {
        layout: 'stacked',
        showContainerBorder: false,
        labelWrap: false,
        isLabel: false,
      };
    // console.log('props.lookupsOptions',props.lookupsOptions);
    const charts = [{
        type:'Grid',
        col:'col-md-3',
        data:[{
            type:"PatientDetails",
            employeeDetails:props.employeeDetails,
            visitDetails:props.visitDetails
        },{
            type:"CompanyDetails",
            companyDetails:props.companyDetails
        }],
    },{
        type:'Tab',
        col:'col-md-9',
        data:[
            {
                id:'urinalysis_details',
                label:'Urinalysis Details',
                data:[
        {
            label:'Activity Details - '+props.activityName,
            note:'Urinalysis is required.  Numerical readings must be recorded.',
            fields:[
                {
                    label:'Protein, blood, or sugar in the urine may be an indication for further testing to rule out any underlying medical problem.',
                    type:'Label',
                    col:'col-12'                
                },
                {
                    label:'Sp. Gr',
                    type:'Decimal',
                    name:'sp_gr',
                    rangeMax:1.030,
                    rangeMin:1.002,
                    id:'sp_gr',
                },
                {
                    label:'Protein',
                    type:'Number',
                    rangeMax:0,
                    name:'protein',
                    id:'protein',
                },
                {
                    label:'Blood',
                    type:'Number',
                    rangeMax:0,
                    name:'blood',
                    id:'blood',
                },
                {
                    label:'Sugar',
                    type:'Number',
                    rangeMax:0,
                    name:'sugar',
                    id:'sugar',
                },
        ]
        },
        {
            label: "Notes",
            // labelStyle: "fw-semibold",
            fieldProps: stackedFieldStyle,
            fields: [
              {
                type: "NewTextArea",
                label: "Notes",
                placeholder: "Add Comments",
                className: "form-control form-control-solid",
                name: "notes",
                col: "col-12 border-0",
              },
              // {
            //     label:'Suggested Result',
            //     type:'TextInput',
            //     disabled:true,
            //     options:isSet(props.lookupsOptions['chartResult'],[]),
            //     name:'suggested_status',
            // },
            // {
            //     type:'Blank',
            //     name:'blank'
            // },
            // {
            //     label:'Final Determination Result',
            //     type:'SelectList',
            //     options:isSet(props.lookupsOptions['chartResult'],[]),
            //     name:'status',
            // },
            ]
          },
        {
            label: 'Review / Completion',
            // labelStyle: 'fw-semibold',
            fields: [
                {
                    type: 'ProviderSignOff',
                    col: 'col-12',
                    fields: [
                        { label: 'Signature PIN', name: 'provider_pin', col: 'col-12' },
                        { label: 'Signature', type: 'NewSignature', name: 'provider_signature', col: 'col-12' },
                        { label: 'Date', type: 'Date', name: 'signed_date', col: 'col-12' },
                        // { label : "Suggested Result", disabled:true,placeholder:'Not Started',type: "TextInput", name: "suggested_status", col: "col-6"},
                        // { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options:isSet(props.lookupsOptions['chartResult'],[]),statusBasedColor: true },
                        { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Normal','Abnormal','Negative','Positive','Dispensed','Administered','Failed','Passed','Non-Negative','Cancelled','Inconclusive']),statusBasedColor: true },
                        // {label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Ordered','Completed','Cancelled']),statusBasedColor: true },
                        {label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Pending Lab Confirmation','Pending MRO Confirmation','Ready for Review','Completed','Cancelled']),statusBasedColor: true },
                    ],
                },
            ],
        }
                ]
            },
            {
                id:'Images',
                label:'Images',
                data:[]
            }
        ]
    }];
    const defaultValue = {
        status:'Not Started',
        suggested_status:'Not Started',
        activity_status:'Not Started',
        // reason:'Pre-employment'
    };
    const headers = [{
        type: 'Tab',
        data: [
            {
                label: 'Urinalysis Details',
                id: 'urinalysis_details'
            },
            {
                label: 'Images',
                id: 'Images'
            }
        ]
    }];
    return {charts,defaultValue,headers,computationFunction: (formData,key) => ({...computationRules(formData,key), ...computationRules1(formData,key)})};
}


const computationRules = (formData,key)=>{
   const spgr    = isSet(formData.sp_gr,'');
   const protein = isSet(formData.protein,'');
   const blood   = isSet(formData.blood,'');
   const sugar   = isSet(formData.sugar,'');

   let status = 'Not Started';
   let activity_status = 'Not Started';

   const sgNormalRange = { min: 1.002, max: 1.030 };
   const sgWithinNormalRange = spgr >= sgNormalRange.min && spgr <= sgNormalRange.max;

   // Check Protein, Blood, and Sugar levels
   const abnormalLevels = protein > 0 || blood > 0 || sugar > 0;

   // Determine status
   if (sgWithinNormalRange && !abnormalLevels) {
        status = "Passed";
        activity_status = 'Completed';
   } else if (!sgWithinNormalRange || abnormalLevels) {
        status = "Failed";
        activity_status = 'Completed';
   } else {
        status = "Pending";
        activity_status = 'Pending';
        status = 'Pending';
   }

   if(spgr ==='' && protein === '' && blood === '' && sugar ==='' ){
    status='Not Started';
    activity_status = 'Not Started';
   }

//    if(xray==="Abnormal"){
//     status = 'Failed';
//    }else if(isSet(xray!=='')){
//         status='Passed';
//    }
    return (key==='status' || key==='activity_status')?{}:{'status':status,'suggested_status':status,'activity_status':activity_status};
}